import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar"
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import FileUploadsComponent from "../../components/FileUploads";
import * as profileActions from "../../redux/actions/profileAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const FileUploads = (props, context) => {
    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);

    const dispatch = useDispatch();
    const modalAction = bindActionCreators(modalActions, dispatch);
    const commonAction = bindActionCreators(commonActions, dispatch);
    const profileAction = bindActionCreators(profileActions, dispatch);


    const getFileHistory = (filelevel) => {
        commonAction.getFileHistory(filelevel);
    }

    const languageChange = (language) => {
        dispatch(setLanguage(language));
    };

    const onMenuToggle = (isOpen) => {
        commonAction.setIsSideMenuOpen(isOpen);
    };

    const openSetModal = (children, size) => {
        modalAction.openSetModal(children, size);
    };

    const closeRemoveModal = () => {
        modalAction.closeRemoveModal();
    };


    const saveTreeView = (treeviewfiledata) => {
        profileAction.saveTreeView(treeviewfiledata);
    }

    const saveEmployeeData = (emplyeeData) => {
        profileAction.saveEmployeeData(emplyeeData);
    }

    return (
        <>
            {window.location.hash !== "#/" && (
                <Sidebar
                    languageChange={languageChange}
                    openSetModalAction={openSetModal}
                    closeRemoveModal={closeRemoveModal}
                    managersDetails={profileReducer.managersDetails}
                    onMenuToggle={onMenuToggle}
                    isSideMenuOpen={commonReducer.isSideMenuOpen}
                    context={context}
                />
            )}
            <div className="Content-Panel">
                <ShowForPermission module={PERMISSON_MODULES.FILE_UPLOADS_PAGE} permission={PERMISSION_TYPE.VIEW}>
                    <FileUploadsComponent
                        saveTreeView={saveTreeView}
                        profileReducer={profileReducer}
                        saveEmployeeData={saveEmployeeData}
                        openSetModalAction={openSetModal}
                        getFileHistory={getFileHistory}
                        fileHistory={commonReducer.fileHistory}
                        closeRemoveModal={closeRemoveModal}
                        context={context}
                    />
                </ShowForPermission>
            </div>
        </>
    )
}

FileUploads.contextTypes = {
    t: PropTypes.func.isRequired,
};
export default FileUploads;